export default __webpack_public_path__ + "static/media/property_357.1ae25af5.png";